var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        // Filter
        // --------------------------------------------------------------------------------------------------------------

        let sortAction = document.querySelector('.block-career-list .filter-sort');
        if (sortAction !== null) {
            sortAction.onchange = function (e) {
                filterList();
            }
        }

        let filterAction = document.querySelector('.block-career-list .btn-filter');
        if (filterAction !== null) {
            filterAction.onclick = function (e) {
                filterList();
            }
        }

        function filterList() {
            let filterCompanyVal = null;
            let filterRoleVal = null;

            let filterCompany = document.querySelector('.filter-company');
            if(filterCompany && filterCompany.length  > 0) {
                filterCompanyVal = filterCompany.options[filterCompany.selectedIndex].value;
            }

            let filterRole = document.querySelector('.filter-role');
            if(filterRole && filterRole.length  > 0) {
                 filterRoleVal = filterRole.options[filterRole.selectedIndex].value;
            }

            let containerCareer = document.querySelector('.block-career-list');

            let url = containerCareer.dataset.url + '?';
            let paramAdd = false;
            if (filterCompanyVal && filterCompanyVal.length > 0) {
                url += 'company=' + filterCompanyVal;
                paramAdd = true;
            }
            if (filterRoleVal && filterRoleVal.length > 0) {
                if (paramAdd != false)
                    url += '&'
                url += 'role=' + filterRoleVal;
            }

            let filterSort = document.querySelector('.filter-sort');
            let filterSortVal = filterSort.options[filterSort.selectedIndex].value;
            if (filterSort.length > 0) {
                if (paramAdd != false)
                    url += '&'
                url += '&sort=' + filterSortVal;
            }

            window.location = url;
        }
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=career-list', initializeBlock);
    }
})

